import { createSlice } from '@reduxjs/toolkit';
import * as actions from './actions';

const initialState = {
    isComposeLoaded: false,
    searchPatients: [],
    templateList: [],
    isComposeSaving: false,
    locationList: [],
    isLocationLoaded: false,
    oneTimePatientCount:0
}

const composeSlice = createSlice({
    name: 'compose',
    initialState,
    reducers: {
        updateOneTimePatientCount(state) {
            state.oneTimePatientCount = 0;
        }
    },
    extraReducers: (builder) => {

        builder.addCase(actions.getPatientsList.pending, (state) => {
            state.isComposeLoaded = false;
        })
        builder.addCase(actions.getPatientsList.fulfilled, (state, action) => {
            if (action.payload.success) {               
               state.searchPatients = action.payload.data;
            } else {       
               state.searchPatients = [];
            }
            state.isComposeLoaded = true;
        })
        builder.addCase(actions.getPatientsList.rejected, (state) => {
            state.isComposeLoaded = false;
        });


        builder.addCase(actions.getTemplateList.pending, (state) => {
            state.isComposeLoaded = false;
        })
        builder.addCase(actions.getTemplateList.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.templateList = action.payload.data;
            } else {
                state.templateList = [];
            }
            state.isComposeLoaded = true;
        })
        builder.addCase(actions.getTemplateList.rejected, (state) => {
            state.isComposeLoaded = false;
        });


        builder.addCase(actions.AddNewCompose.pending, (state) => {
            state.isComposeSaving = true;
        })
        builder.addCase(actions.AddNewCompose.fulfilled, (state, action) => {
            if (action.payload.success) {
                window.location.href = '/sent';
                console.log("AddNewCompose", action.payload);
            } else {
                console.log("AddNewCompose", action.payload);
            }
            state.isComposeSaving = false;
        })
        builder.addCase(actions.AddNewCompose.rejected, (state) => {
            state.isComposeSaving = false;
        });

        builder.addCase(actions.getPeopleByLocationId.pending, (state) => {
            state.isLocationLoaded = false;
        })
        builder.addCase(actions.getPeopleByLocationId.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.oneTimePatientCount = action.payload.data.length;
                
            } else {
                state.oneTimePatientCount = 0;
            }
            state.isLocationLoaded = true;
        })
        builder.addCase(actions.getPeopleByLocationId.rejected, (state) => {
            state.isLocationLoaded = false;
        });

        // GetAllOneTimeGroupLocation

        builder.addCase(actions.getAllLocationOneTimeGroup.pending, (state) => {
            state.isLocationLoaded = false;
        })
        builder.addCase(actions.getAllLocationOneTimeGroup.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.locationList = action.payload.data;
            } else {
                state.locationList = [];
            }
            state.isLocationLoaded = true;
        })
        builder.addCase(actions.getAllLocationOneTimeGroup.rejected, (state) => {
            state.isLocationLoaded = false;
        });

        // UpdateGetAllOneTimeGroupLocation

        builder.addCase(actions.getLocation.pending, (state) => {
            state.isLocationLoaded = false;
        });

        builder.addCase(actions.getLocation.fulfilled, (state, action) => {
            if (action.payload.success) {
                const returnObj = action.payload.data;
                state.locationList.map((refresh)=>{
                    refresh.noOfPeople=0
                })
                returnObj.map((obj) => {                   
                    const locationObj = state.locationList.find(x => x.id === obj.id);
                    if (locationObj !== undefined && locationObj !== null) {                     
                        locationObj.noOfPeople = obj.noOfPeople;
                    }
                });
            }
            state.isLocationLoaded = true;
        });

        builder.addCase(actions.getLocation.rejected, (state) => {
            state.isLocationLoaded = false;
        });


    }
});


export const { updateOneTimePatientCount } = composeSlice.actions

export default composeSlice.reducer;